import { z } from "zod";

// GET request Schemas //

const routingGuideFieldSchema = z.object({
	label: z.string(),
	value: z.string(),
});

const routingGuideRuleSchema = z.object({
	id: z.number(),
	condition: z.string(),
	fieldSelector: z.string(),
	operator: z.string(),
	field1: routingGuideFieldSchema.nullable().optional(),
	field2: routingGuideFieldSchema.nullable().optional(),
	field3: routingGuideFieldSchema.nullable().optional(),
	field4: routingGuideFieldSchema.nullable().optional(),
	field5: routingGuideFieldSchema.nullable().optional(),
	field6: routingGuideFieldSchema.nullable().optional(),
});

const routingGuideCarrierSchema = z.object({
	id: z.number(),
	condition: z.string(),
	fieldSelector: z.string(),
	operator: z.string(),
	field1: routingGuideFieldSchema.optional(),
});

export const routingGuidesSchema = z.object({
	id: z.number(),
	name: z.string(),
	rules: z.array(routingGuideRuleSchema),
	carrier: z.array(routingGuideCarrierSchema),
	customerId: z.number().nullable(),
	createdByName: z.string().nullable().optional(),
	createdDate: z.string(),
	isAutoSelected: z.boolean().optional(),
	isActive: z.boolean().optional(),
	selectionMethod: z.number().nullable().optional(),
	isNewGuide: z.boolean().optional(), // Add a flag to identify new guides
	isExcluded: z.boolean().optional(), // Add a flag to identify excluded guides
	isGlobal: z.boolean(), // Add a flag to identify global guides
});

export const postRoutingGuideSchema = z.object({
	name: z.string(),
	isGlobal: z.boolean(),
	customerId: z.number().nullable(),
	rules: z.array(routingGuideRuleSchema),
	carrier: z.array(routingGuideCarrierSchema),
	isAutoSelected: z.boolean().optional(),
	selectionMethod: z.number().nullable().optional(),
	isActive: z.boolean().optional(),
});

export const putRoutingGuideSchema = postRoutingGuideSchema.extend({
	id: z.number(),
});

const routingGuideEnumItemSchema = z.object({
	value: z.number(),
	name: z.string(),
	label: z.string(),
});

const routingGuideFieldSelectorItemSchema = routingGuideEnumItemSchema.extend({
	operators: z.array(z.number()),
});

export const routingGuideEnumsSchema = z.object({
	conditions: z.array(routingGuideEnumItemSchema),
	ifFieldSelectors: z.array(routingGuideFieldSelectorItemSchema),
	thenFieldSelectors: z.array(routingGuideFieldSelectorItemSchema),
	operators: z.array(routingGuideEnumItemSchema),
	addressFields: z.array(routingGuideEnumItemSchema),
	hoursFields: z.array(routingGuideEnumItemSchema),
	nmfcFields: z.array(routingGuideEnumItemSchema),
	commodityDescriptionFields: z.array(routingGuideEnumItemSchema),
});

export type RoutingGuideRule = z.infer<typeof routingGuideRuleSchema>;

export type RoutingGuideCarrier = z.infer<typeof routingGuideCarrierSchema>;

export type RoutingGuideType = z.infer<typeof routingGuidesSchema>;

export type PostRoutingGuideType = z.infer<typeof postRoutingGuideSchema>;
export type PutRoutingGuideType = z.infer<typeof putRoutingGuideSchema>;
export type RoutingGuideEnumsType = z.infer<typeof routingGuideEnumsSchema>;
export type RoutingGuideEnumItem = z.infer<typeof routingGuideEnumItemSchema>;
export type RoutingGuideFieldSelectorItem = z.infer<
	typeof routingGuideFieldSelectorItemSchema
>;
